export default "__VITE_ASSET__fc73080e__"